import {SecurityFeatureAction, SecurityFeatureActionType, FeatureFlagListAction, FeatureFlagListActionType } from './action-types';
import { ISecurityFeatureState, IFeatureFlagListState } from './types';

export const securityFeatureReducerName = 'securityFeatureReducer';
export const securityFeatureInitialState: ISecurityFeatureState = {
    data: null,
    isLoading: false,
    hasError: false,
    errorMessage: null,
    hasRequested: false,
};

export function securityFeatureReducer(
    prev: ISecurityFeatureState = securityFeatureInitialState,
    action: SecurityFeatureAction): ISecurityFeatureState {
    switch (action.type) {
        case SecurityFeatureActionType.REQUEST_SECURITY_FEATURE:
            return {
                ...prev,
                isLoading: true,
                hasError: false,
                hasRequested: true,
            };

        case SecurityFeatureActionType.RECEIVE_SECURITY_FEATURE: {
            return {
                ...prev,
                isLoading: false,
                hasError: false,
                data: action.data,
            };
        }

        case SecurityFeatureActionType.RECEIVE_SECURITY_FEATURE_ERROR:
            return {
                ...prev,
                isLoading: false,
                hasError: true,
                errorMessage: action.errorMessage,
            };

        case SecurityFeatureActionType.RESET_SECURITY_FEATURE:
            return {
                ...prev,
                data: null,
                hasError: false,
                errorMessage: null,
                isLoading: false,
            };

        default:
            return prev;
    }
}

// Feature Flag List - GetFeatureNamesAsync
export const featureFlagListReducerName = 'featureFlagListReducer';
export const featureFlagListInitialState: IFeatureFlagListState = {
    enabledFeatureFlags: [],
    isLoading: false,
    hasError: false,
    errorMessage: null,
    hasRequested: false,
};

export function featureFlagListReducer(
    prev: IFeatureFlagListState = featureFlagListInitialState,
    action: FeatureFlagListAction): IFeatureFlagListState {
    switch (action.type) {
        case FeatureFlagListActionType.REQUEST_FEATURE_FLAG_LIST:
            return {
                ...prev,
                isLoading: true,
                hasError: false,
                hasRequested: true,
            };

        case FeatureFlagListActionType.RECEIVE_FEATURE_FLAG_LIST: {
            return {
                ...prev,
                isLoading: false,
                hasError: false,
                enabledFeatureFlags: action.data,
            };
        }

        case FeatureFlagListActionType.RECEIVE_FEATURE_FLAG_LIST_ERROR:
            return {
                ...prev,
                isLoading: false,
                hasError: true,
                errorMessage: action.errorMessage,
            };

        case FeatureFlagListActionType.RESET_FEATURE_FLAG_LIST:
            return {
                ...prev,
                enabledFeatureFlags: [],
                hasError: false,
                errorMessage: null,
                isLoading: false,
            };

        default:
            return prev;
    }
}